import { render, staticRenderFns } from "./billof.vue?vue&type=template&id=41f1f6cc&scoped=true&"
import script from "./billof.vue?vue&type=script&lang=js&"
export * from "./billof.vue?vue&type=script&lang=js&"
import style0 from "./billof.vue?vue&type=style&index=0&id=41f1f6cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1f6cc",
  null
  
)

export default component.exports